// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2TGku","content":"layout-module--content--3nIku","cookiesContainer":"layout-module--cookiesContainer--1s5r5"};